import axios from "axios";
import { Url } from "../Component/function/FunctionApi";
import { getCookie } from "../Pages/Login/Login";

const authHeaders = () => ({
  Authorization: `Bearer ${getCookie("user") ? JSON.parse(getCookie("user")).token : ""}`,
});

const serializeParams = (params) => {
  const normalized = { ...(params || {}) };

  // Normalize a single 'code' string like "253861-252600" into 'codes' array
  if (!normalized.codes && typeof normalized.code === "string") {
    const parts = normalized.code
      .split("-")
      .map((p) => p.trim())
      .filter(Boolean);
    if (parts.length > 0) {
      normalized.codes = parts;
    }
    delete normalized.code;
  }

  // If 'codes' was provided as a hyphen-delimited string, split it
  if (
    typeof normalized.codes === "string" &&
    normalized.codes.includes("-")
  ) {
    normalized.codes = normalized.codes
      .split("-")
      .map((p) => p.trim())
      .filter(Boolean);
  }

  const usp = new URLSearchParams();
  Object.entries(normalized).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => usp.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      usp.append(key, value);
    }
  });
  return usp.toString();
};

export const getInvoices = async (params) => {
  const response = await axios.get(`${Url}Invoice/GetAllInvoices`, {
    headers: authHeaders(),
    params,
    paramsSerializer: (p) => serializeParams(p),
  });
  return response.data;
};

export const getInvoiceById = async (id) => {
  const response = await axios.get(`${Url}Invoice/get-invoiceByid`, {
    headers: authHeaders(),
    params: { id },
  });
  return response.data;
};

export const updateInvoice = async (invoiceId, payload) => {
  const response = await axios.put(`${Url}Invoice/update/${invoiceId}`, payload, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  });
  return response;
};

export const deleteInvoice = async (invoiceId) => {
  const response = await axios.delete(`${Url}Invoice/invoice`, {
    headers: authHeaders(),
    params: { id: invoiceId },
  });
  return response;
};

export const addInvoiceCategory = async (invoiceId, items) => {
  const response = await axios.post(
    `${Url}Invoice/AddInvoiceCategory`,
    items,
    {
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      params: { invoiceId },
    }
  );
  return response;
};

export const updateInvoiceCategories = async (invoiceId, items) => {
  const response = await axios.put(
    `${Url}Invoice/invoice-categories`,
    items,
    {
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      params: { invoiceId },
    }
  );
  return response;
};

export const deleteInvoiceCategoryById = async (categoryId) => {
  const response = await axios.delete(`${Url}Invoice/delete-invoice-categoryByid`, {
    headers: authHeaders(),
    params: { categoryid: categoryId },
  });
  return response;
};

export const getPhoneNumbers = async () => {
  const response = await axios.get(`${Url}Invoice/GetPhoneNumbers`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getGovernorates = async () => {
  const response = await axios.get(`${Url}Governorate/get-governorates`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getCategories = async () => {
  const response = await axios.get(`${Url}Category/get-categories`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getRepresentatives = async () => {
  const response = await axios.get(`${Url}Represntative/get-Represntatives`, {
    headers: authHeaders(),
  });
  return response.data;
}; 